import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 33%;
  border-radius: 4px;
  border: 1px solid var(--grey200);
  background: var(--grey200);
  display: flex;
  height: 40px;
  padding: 8px 4px 8px 8px;
  align-items: center;
  gap: 16px;
  ${(props) =>
    !!props.isReadonly &&
    css`
      border: 1px solid var(--grey300);
    `}
`;
